exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  font-family: sans-serif;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  background-image: url(" + require("../images/mts.jpeg") + ");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #ffff00; }\n\n.alert {\n  margin: 30px; }\n\nbody, html {\n  height: 100%;\n  margin: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/css/index.scss
// module id = 58
// module chunks = 0